import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { noAccess } from '../api'
import Modal from './Modal'

export default class ContactUsModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: props.sessionEmail,
			first_name: '',
			last_name: '',
			job_title: '',
			company: '',
			contacting: false
		}
	}

	// Handle them dismissing the modal
	modalDismissed = () => {		
		this.props.modalDismissed()
		this.setState({toEmail: '', first_name: '', last_name: '', job_title: '', company: ''})
	}

	handleSubmit = async (e) => {
		e.preventDefault()
		this.setState({contacting: true})
		await noAccess(this.state)
		
		this.setState({contacting: false, first_name: '', last_name: '', job_title: '', company: ''})
		this.props.modalDismissed()
	}

	handleInputChange = ({target: {id, type, value, checked}}) => {
		const newValue = type === 'checkbox' ? checked : value
		this.setState(() => {return {[id]: newValue}})
	}

	render() {
		let {email, first_name, last_name, job_title, company, contacting} = this.state
		return (
			<Modal display={this.props.display} modalDismissed={this.modalDismissed}>
				<Fragment>
					<img src="https://www.datocms-assets.com/3323/1528912402-mail.png" alt="mail icon" />
					<p>Fill out the form below to speak to an expert and learn more.</p>
					<form onSubmit={this.handleSubmit}>
						<input id="email" type="email" placeholder="Email Address" value={email || ''} onChange={this.handleInputChange} />
						<input id="first_name" type="text" placeholder="First Name" value={first_name} onChange={this.handleInputChange} />
						<input id="last_name" type="text" placeholder="Last Name" value={last_name} onChange={this.handleInputChange} />
						<input id="job_title" type="text" placeholder="Job Title" value={job_title} onChange={this.handleInputChange} />
						<input id="company" type="text" placeholder="Company" value={company} onChange={this.handleInputChange} />
						{/* <input
							id="newsletter"
							type="checkbox"
							checked={newsletter}
							onChange={this.handleInputChange} />
						<label htmlFor="newsletter">Add me to your newsletter!</label> */}
						<button className="cta" type="button" onClick={this.handleSubmit} disabled={contacting}>
							{contacting ? 'Submitting Your Info...' : 'Get Started'}
						</button>
					</form>
				</Fragment>
			</Modal>
		)
	}
}

ContactUsModal.propTypes = {
	display: PropTypes.bool,
	modalDismissed: PropTypes.func,
	sessionEmail: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/ContactUsModal.js